import { type PromotionPlacement } from '@onr/schema'

import { type PromotionFormData } from '@/components/organisms/PromotionForm/PromotionFormZod'

export const fromFormValues = (
  formData: PromotionFormData,
  enabledPlacements?: Partial<Record<PromotionPlacement, boolean>>
) => ({
  ...formData,
  placements: Object.entries(formData.placements)
    .filter(([key, value]) => value && (!enabledPlacements || enabledPlacements[key as PromotionPlacement]))
    .map(([key]) => key as PromotionPlacement),
  creativeUrls: Object.fromEntries(Object.entries(formData.creativeUrls).filter(([, value]) => !!value)),
})
